import { render, staticRenderFns } from "./RoleBranchComponent.vue?vue&type=template&id=0496fccc&scoped=true&"
import script from "./RoleBranchComponent.vue?vue&type=script&lang=ts&"
export * from "./RoleBranchComponent.vue?vue&type=script&lang=ts&"
import style0 from "./RoleBranchComponent.vue?vue&type=style&index=0&id=0496fccc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0496fccc",
  null
  
)

export default component.exports